export class MessageResponse {
  constructor(public messageKey: string,
              public name: string,
              public message: string,
              public startDate: Date,
              public endDate: Date,
              public active: boolean) {
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/banner/message-response.ts